import { createGtmApi } from '@sleepstation/tracking'
import TagManager from 'react-gtm-module'
import { getEnvironment } from '../utils/environment'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const configureGoogleTagManager = () => {
  const {
    SERVICE: {
      GOOGLE_TAG_MANAGER: { ID, AUTH, PREVIEW },
    },
  } = getEnvironment()

  TagManager.initialize({
    gtmId: ID,
    auth: AUTH,
    preview: PREVIEW,
  })

  return createGtmApi()
}

export default configureGoogleTagManager
